import { render, staticRenderFns } from "./CrearSolicitud.vue?vue&type=template&id=1b4e5656&"
import script from "./CrearSolicitud.vue?vue&type=script&lang=ts&"
export * from "./CrearSolicitud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports